import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Stage } from '../../../../types/bookings';
import BookingStageDivider from '../BookingStageDivider';
import BookingStageIcon from '../BookingStageIcon';
import { StyledWrapper } from './BookingRequestStage.styles';

const BookingRequestStage = ({ stage }: { stage: Stage }) => {
  const { t } = useTranslation(['bookingStageInformation']);
  const isPending = (stage: Stage): boolean => stage === Stage.Pending;
  const isRejected = (stage: Stage): boolean => stage === Stage.Rejected;
  const isAccepted = (stage: Stage): boolean =>
    [
      Stage.Accepted,
      Stage.CreditNotVerified,
      Stage.CreditVerified,
      Stage.ContractCreated,
      Stage.ContractNotSigned,
      Stage.ContractSigned,
      Stage.CheckInKo,
      Stage.CheckInOk,
    ].includes(stage);

  return (
    <>
      <StyledWrapper
        isPending={isPending(stage)}
        isAccepted={isAccepted(stage)}
        isRejected={isRejected(stage)}
      >
        <BookingStageIcon
          isPending={isPending(stage)}
          isAccepted={isAccepted(stage)}
          isRejected={isRejected(stage)}
        />
        {upperFirst(t('bookingStageInformation:bookingRequest'))}
      </StyledWrapper>
      <BookingStageDivider isAccepted={isAccepted(stage)} />
    </>
  );
};

export default BookingRequestStage;
